import SupplementalDocsDescription from '../../components/FormDescriptions/SupplementalDocsDescription';
import content from '../../locales/en/content.json';
import { ATTACHMENT_IDS } from '../../utils/constants';
import { createDocumentPages } from '../../utils/pageBuilders';

const SCHEMA_ENUM = [
  ATTACHMENT_IDS.birthCert,
  ATTACHMENT_IDS.civilUnionCert,
  ATTACHMENT_IDS.adoptionPapers,
  ATTACHMENT_IDS.divorceDecree,
  ATTACHMENT_IDS.driversLicense,
  ATTACHMENT_IDS.marriageCert,
  ATTACHMENT_IDS.passport,
  ATTACHMENT_IDS.schoolCertificationForm,
  ATTACHMENT_IDS.socialSecurityCard,
];

export const supportingDocPages = createDocumentPages({
  pagePath: 'supporting-documents',

  attachmentId: {
    title: content['supplemental--docs-type-label'],
    labels: SCHEMA_ENUM,
  },
  arrayPath: 'supplementalDocsUpload',
  required: true,

  summaryTitle: content['supplemental--docs-summary-title'],
  summaryDescription: SupplementalDocsDescription,
  uploadTitle: content['supplemental--docs-upload-title'],
  uploadTitleAddOn: content['supplemental--docs-upload-description'],
  uploadLabel: content['supplemental--docs-upload-label'],
});
